import React from 'react';
import { iconPropTypes, iconDefaultProps } from '../iconPropTypes';

const NewIcon = ({ fill, width, height, ...props }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg" fill="none" {...props}>
            <path d="M15.5001 3.33325C15.9603 3.33325 16.3334 3.70635 16.3334 4.16659V10.8333C16.3334 11.2935 15.9603 11.6666 15.5001 11.6666C15.0398 11.6666 14.6667 11.2935 14.6667 10.8333V4.16659C14.6667 3.70635 15.0398 3.33325 15.5001 3.33325Z" fill={fill} />
            <path d="M3.83325 15.0001C3.83325 14.5398 4.20635 14.1667 4.66659 14.1667H11.3333C11.7935 14.1667 12.1666 14.5398 12.1666 15.0001C12.1666 15.4603 11.7935 15.8334 11.3333 15.8334H4.66659C4.20635 15.8334 3.83325 15.4603 3.83325 15.0001Z" fill={fill} />
            <path d="M6.92259 5.24408C6.59715 4.91864 6.06952 4.91864 5.74408 5.24408C5.41864 5.56952 5.41864 6.09715 5.74408 6.42259L11.5774 12.2559C11.9028 12.5813 12.4305 12.5813 12.7559 12.2559C13.0813 11.9305 13.0813 11.4028 12.7559 11.0774L6.92259 5.24408Z" fill={fill} />
        </svg >
    );
}

NewIcon.propTypes = iconPropTypes
NewIcon.defaultProps = iconDefaultProps

export default NewIcon;
